import { Box, Button, Grid, Stack, Typography } from '@mui/material';
import {
  GridToolbarContainer,
  GridToolbarExport,
  GridToolbarDensitySelector,
  GridToolbarFilterButton,
  GridToolbarColumnsButton,
  GridToolbarQuickFilter,
  GridMoreVertIcon
} from '@mui/x-data-grid';
import { useState } from 'react';
import { useTheme } from '@mui/material/styles';
import useMain from 'hooks/useMain';

const GridToolbarCustom = ({ cusToolbarComponents = () => null, showExport = true, showSearchBar = true, isBatchUpdate = false}) => {
  const [anchorElMenu, setAnchorElMenu] = useState();
  const openMenu = Boolean(anchorElMenu);
  const theme = useTheme();
  const {t} = useMain();
  return (
    <GridToolbarContainer sx={{ mb: '12px' }}>
      {/* search bar out of stack */}
      {/* add batchupdate ui checking */}
      {isBatchUpdate && <Typography color={theme.palette.primary[400]} fontSize='medium'>{t('BATCH_SELECTED')}</Typography>}
      {showSearchBar && <GridToolbarQuickFilter sx={{ ml: [0, 2], mt: [2, 'auto'], '.MuiInputBase-root':{borderRadius:'7px'} }} variant='outlined' placeholder={t('SEARCH')}/>}
      
      <Stack ml="auto" direction={['column', 'row']} width={['100%', 'auto']}>

        {showExport && <GridToolbarExport variant="contained" />}

        {cusToolbarComponents()}

      </Stack>
      {/* 
      <Grid>
        <Button
          variant="contained"
          size="small"
          //   disabled={selectionModel.length === 0}
          startIcon={<GridMoreVertIcon />}
          onClick={(event) => {
            setAnchorElMenu(event.currentTarget);
          }}
        >
          Actions
        </Button>

        <Menu
          id="menu-options"
          anchorEl={anchorElMenu}
          open={openMenu}
          onClose={() => {
            setAnchorElMenu(null);
          }}
        >
          <MenuItem /> //Clipped
          <MenuItem /> //Clipped
          <MenuItem /> //Clipped
        </Menu>
      </Grid> */}
    </GridToolbarContainer>
  );
};

export default GridToolbarCustom;
